import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { Grid, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { injectIntl } from 'react-intl';
import Typography from "@mui/material/Typography";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import CheckIcon from '@mui/icons-material/Check';



function DialogUserAlreadyExistsOptInMe(props) {

  const intl = props.intl;



  return (
    <div>


      <Dialog open={props.open} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: "bold" }}>Atualização de Acesso – Portal de Serviços

          <IconButton sx={{ position: "absolute", right: 8, top: 8 }} onClick={props.openOrCloseModalFunction}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent >
          <Typography variant="body1" sx={{ marginTop: 1 }}>
          Seu  <strong>CPF</strong> já possui cadastro ativo neste Portal. 
          Para unificar seus dados, faremos a sincronização automática com sua conta <strong>gov.br</strong>.


          </Typography>
           <Typography variant="body1" gutterBottom sx={{ marginTop: 2 }}>
            <strong>Importante: </strong> A partir de agora, <strong> o acesso será exclusivo via <strong>gov.br</strong>.</strong> 
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ marginTop: 2 }}>
            O processo levará alguns minutos e, ao final, você receberá um e-mail confirmando a liberação do acesso.
          </Typography>
           <Typography variant="body1" gutterBottom sx={{ marginTop: 2 }}>
           <strong>Atenção: </strong> Outras formas de login não estarão mais disponíveis.
          </Typography>
          <Typography variant="body1" gutterBottom sx={{ marginTop: 2 }}>
           Clique em <strong>“Ciente”</strong> para confirmar e continuar.
          </Typography>
          {/* <Typography variant="body1" gutterBottom sx={{ marginTop: 2 }}>
            <strong>Dados do gov.br:</strong>
          </Typography>
          <Typography variant="body2">Nome: {props.name}</Typography>
          <Typography variant="body2">E-mail: {props.email}</Typography>
          <Typography variant="body2">CPF: {props.document}</Typography>

          <Typography variant="body1" gutterBottom sx={{ marginTop: 2 }}>
            <strong>Dados encontrados no Portal da Central de Atendimento  </strong>aos sistemas estruturantes do Ministério da Gestão e da Inovação em Serviços Públicos
          </Typography>
        
          <Box>
            {props.userAlreadyInSystem && props.userAlreadyInSystem.length > 0 ? props.userAlreadyInSystem.map((item) => (
              <Paper
                key={item.id}
                sx={{ padding: 1, marginBottom: 1, backgroundColor: "#f5f5f5" }}
                elevation={0}
              >
                <Typography variant="body2"  >
                  ID: {item.id}, Nome: {item.name}, E-mail: {item.email}, Cpf: {item.document}
                  {item.id == props.userId &&
                    <>
                      <span style={{
                        fontWeight: 'bolder',
                        color: 'black',
                        marginLeft: '10px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px'
                      }}>  Conta oficial GOV.BR <CheckIcon style={{
                        color: 'green',
                        verticalAlign: 'middle',
                        fontSize: '1.3em', 
                        marginLeft: '3px' 
                      }} /></span>
                    </>

                  }

                  {item.id != props.userId &&
                    <>
                      <span style={{
                        fontWeight: 'bolder',
                        color: 'black',
                        marginLeft: '10px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px'
                      }}>  Conta será unificada</span>
                    </>

                  }





                </Typography>

              </Paper>
            )) : null}
          </Box> */}


          {/* <Typography variant="body1" sx={{ marginTop: 2 }}>
            O CPF informado já está associado a uma conta no <strong>Portal da Central de Atendimento</strong> aos sistemas estruturantes do Ministério da Gestão e da Inovação em Serviços Públicos. Deseja sobrescrever os dados existentes com as informações do seu cadastro no GOV.BR?
            Essa ação substituirá as informações atuais. Caso queira prosseguir, clique em 'Sim'. Se preferir manter os dados atuais, clique em 'Não'.

          </Typography> */}




        </DialogContent>
        <DialogActions mb={2} >

          <Grid container spacing={2} >
            <Grid item xs={12} >
              <Stack direction="row" spacing={4} justifyContent="end">
               
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ paddingX: 6, marginBottom:'10px', marginRight:'10px', textTransform: 'none' }}
                  onClick={props.handleConfirmation}
                >
                  Ciente
                </Button>
              </Stack>
            </Grid>
          </Grid>




        </DialogActions>
      </Dialog>

    </div>
  );
}

export default injectIntl(DialogUserAlreadyExistsOptInMe);